import React from "react";

export const SkeletonRect = () => {
  return <div className="skeleton"></div>;
};

export default SkeletonRect;
